export const EDIT_CONDITIONAL_PANEL_ID = 'edit_conditional_panel_id';
